import React from 'react';

import UseToast from 'hooks/use-toast';
import ExploreContentCardNew from 'components/common/ExploreContentCardNew/ExploreContentCardNew';

import classes from './TopCareerPath.module.scss';
import LinkButton from '@core/components/linkbutton/LinkButton';
import CareerPathWrapper from 'components/pages/explore/explorewrappernew/topcareerpath/careerpathwrapper/CareerPathWrapper';


const TopCareerPath = ({ career_paths }) => {
    const { toast, ToastContainer } = UseToast();

    return (
        <>
            <div className={`${classes['wrapper']} container`}>
                <div className="row d-flex justify-content-center">
                    <div className='col-xxl-10 col-12'>
                        {career_paths.map((path) => (
                            <div key={path.id} className={classes['career-path-wrapper']}>
                                <div className='d-flex flex-wrap align-items-center justify-content-between'>
                                    <h3 className={classes['career-path-title']}>Top <span>{path.short_name || path.name}</span> Courses</h3>
                                    <LinkButton to={`/career-path/${path.id}/${path.slug}`} kind='secondary-simple' className={classes['view-all-button']}>
                                        View all {path.short_name || path.name} Courses
                                    </LinkButton>
                                </div>
                                <div className="row">
                                   <CareerPathWrapper career_path={path} toast={toast} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>

    );
};

export default TopCareerPath;